// extracted by mini-css-extract-plugin
export default {"Loader":"Preloader_Loader__ryrRm","loader":"Preloader_loader__YAh+q","loader-inner":"Preloader_loader-inner__7xd93"};